module.exports = __webpack_public_path__ + "55d875313e2331765c3fd19e6f2bf8be.eot";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-BoldItalic.eot
// module id = 22
// module chunks = 0